import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { WbTokenInfo } from "@acc/shared"
import { RootState } from "../store"
import BaseApi from "../../api/api"

type WBTokenStatus = {
  blocking: string[]
  nonBlocking: string[]
  /** Декодированная инфа о WB-токене (тип/разрешения/срок). null, если неизвестно. */
  tokenInfo: WbTokenInfo | null
  loaded: boolean
}

const initialState: WBTokenStatus = {
  blocking: [],
  nonBlocking: [],
  tokenInfo: null,
  loaded: false,
}

export const fetchWBTokenStatus = createAsyncThunk(
  "wbToken/fetch",
  async (_, { dispatch }) => {
    const response = await BaseApi.getWBTokenStatus()
    const {
      blocking = [],
      nonBlocking = [],
      tokenInfo = null,
    } = response.data || {}
    dispatch(setWBTokenStatus({ blocking, nonBlocking, tokenInfo }))
    return response.data
  },
)

const wbTokenSlice = createSlice({
  name: "wbToken",
  initialState,
  reducers: {
    setWBTokenStatus: (
      state,
      action: PayloadAction<{
        blocking: string[]
        nonBlocking: string[]
        tokenInfo?: WbTokenInfo | null
      }>,
    ) => {
      state.blocking = action.payload.blocking
      state.nonBlocking = action.payload.nonBlocking
      // tokenInfo может прийти undefined (старый вызов без поля) — сохраняем прежнее.
      if (action.payload.tokenInfo !== undefined) {
        state.tokenInfo = action.payload.tokenInfo
      }
      state.loaded = true
    },
  },
  extraReducers: (builder) => {
    // При ошибке/401 thunk реджектится. Ставим loaded: true, чтобы
    // WBTokenGuard не блокировал защищённые табы бесконечно; списки
    // предупреждений остаются пустыми — статус неизвестен, UI показываем как есть.
    builder.addCase(fetchWBTokenStatus.rejected, (state) => {
      state.loaded = true
    })
  },
})

export const selectWBTokenBlocking = (state: RootState) =>
  state.wbToken.blocking
export const selectWBTokenNonBlocking = (state: RootState) =>
  state.wbToken.nonBlocking
export const selectWBTokenLoaded = (state: RootState) => state.wbToken.loaded
export const selectWBTokenInfo = (state: RootState) => state.wbToken.tokenInfo

export const { setWBTokenStatus } = wbTokenSlice.actions
export default wbTokenSlice.reducer
